export const login = '/auth/login';
export const forgotPassword = '/auth/recover-password';
export const setPassword = '/auth/set-password';
